import { Access } from './Forms/Access';
import { Aggregate } from './Forms/Aggregate';
import { Bin } from './Forms/Bin';
import { DatePart } from './Forms/DatePart';
import { DateTrunc } from './Forms/DateTrunc';
import { Difference } from './Forms/Difference';
import { PctDifference } from './Forms/PctDifference';
import { PctOfTotal } from './Forms/PctOfTotal';
import { Generic } from './Forms/Generic';
import { ExprForm } from './ExprForm';
export var Expr;
(function (Expr) {
    function match(root) {
        if (Access.matches(root)) {
            return ExprForm.Access;
        }
        else if (DatePart.matches(root)) {
            return ExprForm.DatePart;
        }
        else if (DateTrunc.matches(root)) {
            return ExprForm.DateTrunc;
        }
        else if (Aggregate.matches(root)) {
            return ExprForm.Aggregate;
        }
        else if (Difference.matches(root)) {
            return ExprForm.Difference;
        }
        else if (PctDifference.matches(root)) {
            return ExprForm.PctDifference;
        }
        else if (PctOfTotal.matches(root)) {
            return ExprForm.PctOfTotal;
        }
        else if (Bin.matches(root)) {
            return ExprForm.Bin;
        }
        else {
            return ExprForm.Generic;
        }
    }
    Expr.match = match;
    let Parsed;
    (function (Parsed) {
        function make(root) {
            switch (match(root)) {
                case ExprForm.Access:
                    return Access.parse(root);
                case ExprForm.DatePart:
                    return DatePart.Parsed.make(root);
                case ExprForm.DateTrunc:
                    return DateTrunc.Parsed.make(root);
                case ExprForm.Aggregate:
                    return Aggregate.parse(root);
                case ExprForm.Difference:
                    return Difference.Parsed.make(root);
                case ExprForm.PctDifference:
                    return PctDifference.Parsed.make(root);
                case ExprForm.PctOfTotal:
                    return PctOfTotal.Parsed.make(root);
                case ExprForm.Bin:
                    return Bin.parse(root);
                default:
                    return Generic.Parsed.make(root);
            }
        }
        Parsed.make = make;
    })(Parsed = Expr.Parsed || (Expr.Parsed = {}));
})(Expr || (Expr = {}));
